'use client';
import Image, { StaticImageData } from 'next/image';
import React from 'react';
import { useRouter } from 'next/navigation';

interface imagestype {
    img: string | StaticImageData;
    imgtitle: string;
    navigation?: string;
    aspectRatio?: string;
}

export const PlaceImage = ({ img, imgtitle, aspectRatio, navigation }: imagestype) => {
    const router = useRouter();

    return (
        <div
            className='relative image cursor-pointer w-full h-full'
            onClick={() => {
                if (navigation) {
                    router.push(navigation);
                }
            }}
        >
            <Image
                src={img}
                alt={imgtitle}
                className='rounded-[20px] object-cover w-full h-full'
                style={{ aspectRatio: aspectRatio }}
            />
            <div
                style={{
                    background: 'linear-gradient(180deg, rgba(5, 7, 60, 0) 50%, #000000 100%)',
                    boxShadow: '0px 4px 4px 0px #00000040',
                    borderRadius: '20px',
                }}
                className='w-full h-full absolute top-0 '
            ></div>
            <div className='absolute bottom-7 end-0 left-0 flex justify-center'>
                <h4 className='text-white font-bold capitalize tracking-wider'>{imgtitle}</h4>
            </div>
        </div>
    );
};
